export default __webpack_public_path__ + "18c1c2e28ef39422c67680d84b65ced1.svg";